import React from "react";
import { Grid, withStyles } from "@material-ui/core";
import ModuleNumber from "../ModuleNumber";
import { ModuleDetails } from "./ModuleDetails";

const Module = ({ classes, data, number }) => (
  <Grid container justify={'center'}>
    <Grid item md={1} className={classes.moduleNumberItem}>
      <ModuleNumber number={number} />
    </Grid>
    <Grid item xs={12} md={8}>
      <ModuleDetails data={data} />
    </Grid>
  </Grid>
);


const styles = theme => ({
  moduleNumberItem: {
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  }
});

export default withStyles(styles)(Module);
